import script from "./RewardDetailCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RewardDetailCard.vue?vue&type=script&setup=true&lang=js"

import "./RewardDetailCard.vue?vue&type=style&index=0&id=75c3bbaa&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75c3bbaa"]])

export default __exports__